module.exports = __webpack_public_path__ + "static/img/myEmbryOne.f4c5f42.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/myEmbryOne.png
// module id = IYXU
// module chunks = 5